export default __webpack_public_path__ + "static/media/camera.b1b45cec.png";